import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
	CLEAR_ATTENDANCE_RECORDS,
	GET_ATTENDANCE_HISTORY_CALL,
	GET_ATTENDANCE_HISTORY_DONE,
	GET_ATTENDANCE_HISTORY_FAIL,
	GET_PUNCH_IN_RECORDS_CALL,
	GET_PUNCH_IN_RECORDS_DONE,
	GET_PUNCH_IN_RECORDS_FAIL,
	PUT_PUNCH_IN_RECORD_CALL,
	PUT_PUNCH_IN_RECORD_DONE,
	PUT_PUNCH_IN_RECORD_FAIL,
} from '@src/store/types';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	attendanceHistory: [],
	getAttendanceHistorySideEffect: defaultSideEffectState,
	punchInRecords: [],
	getPunchInRecordsSideEffect: defaultSideEffectState,
	punchInRecordsQuery: null,
	putPunchInRecordSideEffect: defaultSideEffectState,
};

export default handleActions({
	[CLEAR_ATTENDANCE_RECORDS](state) {
		return update(state, {
			attendanceHistory: { $set: [] },
			getAttendanceHistorySideEffect: { $set: defaultSideEffectState },
			punchInRecords: { $set: [] },
			getPunchInRecordsSideEffect: { $set: defaultSideEffectState },
			punchInRecordsQuery: { $set: null },
		});
	},
	[GET_ATTENDANCE_HISTORY_CALL](state) {
		return update(state, {
			getAttendanceHistorySideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_ATTENDANCE_HISTORY_DONE](state, { payload: { res } }) {
		return update(state, {
			attendanceHistory: { $set: res },
			getAttendanceHistorySideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_ATTENDANCE_HISTORY_FAIL](state, { payload }) {
		return update(state, {
			getAttendanceHistorySideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PUNCH_IN_RECORDS_CALL](state, { payload }) {
		return update(state, {
			punchInRecordsQuery: { $set: { userId: payload.user_id, date: payload.query_date } },
			getPunchInRecordsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PUNCH_IN_RECORDS_DONE](state, { payload: { res } }) {
		return update(state, {
			punchInRecords: { $set: res?.records || [] },
			getPunchInRecordsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PUNCH_IN_RECORDS_FAIL](state, { payload }) {
		return update(state, {
			getPunchInRecordsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[PUT_PUNCH_IN_RECORD_CALL](state) {
		return update(state, {
			putPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[PUT_PUNCH_IN_RECORD_DONE](state) {
		return update(state, {
			putPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[PUT_PUNCH_IN_RECORD_FAIL](state, { payload }) {
		return update(state, {
			putPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
